import React from "react";
import { Routes, Route } from "react-router-dom";

import List from "./list";
import ViewIndex from "./view";
import Add from "./add";

const Device = () => {
  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path="/add" element={<Add />} />
      <Route path="/:id/*" element={<ViewIndex />} /> 
    </Routes>
  );
};

export default Device;
